import {request} from "@/shared/api/http";

type OnboardingSource = 'ISMET-DOCS' | 'COUNTER-PARTY' | 'EXPAND-TABLE-ROW';

/**
 * Пройденный онбординг назад не откатывается, поэтому ответ держим до перезагрузки страницы:
 * без этого, например, таблица документов спрашивала бы про подсказку при каждом заходе в раздел.
 */
const cache = new Map<OnboardingSource, Promise<boolean>>();

export const getOnBoarding = (source: OnboardingSource): Promise<boolean> => {
    let result = cache.get(source);
    if (!result) {
        result = request.get(`/proxy/tracking-action.bpmn/api/v1/onboarding/by-source/${source}`)
            .then(response => response.data.onboarding);
        // Ошибку не запоминаем — следующий вызов спросит бэк заново
        result.catch(() => cache.delete(source));
        cache.set(source, result);
    }
    return result;
}

/** Онбординг у каждого пользователя свой — при выходе из аккаунта ответы забываем. */
export const resetOnBoardingCache = () => cache.clear();

export const markOnBoarding = async (source: OnboardingSource) => {
    cache.set(source, Promise.resolve(true));
    return (await request.post(`/proxy/tracking-action.bpmn/api/v1/onboarding/by-source/${source}`)).data;
}
